export default __webpack_public_path__ + "static/media/icon_recycle.a16984fc.svg";